import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';

export const fetchAnomalyLogs = createAsyncThunk(
  'soilAnomalyLogs/fetchAnomalyLogs',
  async ({ page = 1, limit = 20, status = 'all', sample_id = '' } = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({ page, limit, status });
      if (sample_id) params.append('sample_id', sample_id);
      const { data } = await axiosInstance.get(`/super-admin/anomaly-logs?${params.toString()}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const markLogFixed = createAsyncThunk(
  'soilAnomalyLogs/markLogFixed',
  async ({ ids, fixed_by, fixed_reason }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.put(`/super-admin/anomaly-logs/fix`, { ids, fixed_by, fixed_reason });
      return data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const fetchAnomalyReasons = createAsyncThunk(
  'soilAnomalyLogs/fetchAnomalyReasons',
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/super-admin/anomaly-logs/${id}/reasons`);
      return { id, reasons: data.data || [] };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const soilAnomalyLogSlice = createSlice({
  name: 'soilAnomalyLogs',
  initialState: {
    logs:       [],
    total:      0,
    page:       1,
    totalPages: 1,
    status:     'idle',
    error:      null,
    reasonsByLogId: {},
    reasonsStatus: 'idle',
    reasonsError: null,
  },
  reducers: {
    clearAnomalyLogs: (state) => {
      state.logs       = [];
      state.total      = 0;
      state.page       = 1;
      state.totalPages = 1;
      state.status     = 'idle';
      state.error      = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnomalyLogs.pending, (state) => {
        state.status = 'loading';
        state.error  = null;
      })
      .addCase(fetchAnomalyLogs.fulfilled, (state, action) => {
        state.status     = 'succeeded';
        state.logs       = action.payload.data;
        state.total      = action.payload.total;
        state.page       = action.payload.page;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchAnomalyLogs.rejected, (state, action) => {
        state.status = 'failed';
        state.error  = action.payload;
      })
      .addCase(markLogFixed.fulfilled, (state, action) => {
        const updatedLogs = action.payload || [];
        updatedLogs.forEach(updated => {
          const idx = state.logs.findIndex((l) => l.id === updated.id);
          if (idx !== -1) state.logs[idx] = updated;
        });
      })
      .addCase(fetchAnomalyReasons.pending, (state) => {
        state.reasonsStatus = 'loading';
        state.reasonsError = null;
      })
      .addCase(fetchAnomalyReasons.fulfilled, (state, action) => {
        state.reasonsStatus = 'succeeded';
        state.reasonsByLogId[action.payload.id] = action.payload.reasons;
      })
      .addCase(fetchAnomalyReasons.rejected, (state, action) => {
        state.reasonsStatus = 'failed';
        state.reasonsError = action.payload;
      });
  },
});

export const { clearAnomalyLogs } = soilAnomalyLogSlice.actions;
export default soilAnomalyLogSlice.reducer;